import apiClient from "../authentication/utils/core/axios";

const PortfolioAPI = {
  // --- Portfolio ---
  create: async (portfolioData) => {
    const res = await apiClient.post('/portfolios/', portfolioData);
    if (res.status !== 201) throw new Error('Failed to create portfolio');
    return res.data;
  },

  fetchAll: async () => {
    const res = await apiClient.get('/portfolios/');
    if (res.status !== 200) throw new Error('Failed to fetch portfolios');
    return res.data;
  },

  fetchById: async (id) => {
    const res = await apiClient.get(`/portfolios/${id}`);
    if (res.status !== 200) throw new Error('Failed to fetch portfolio by ID');
    return res.data;
  },

  update: async (id, portfolioData) => {
    const res = await apiClient.put(`/portfolios/${id}`, portfolioData);
    if (res.status !== 200) throw new Error('Failed to update portfolio');
    return res.data;
  },

  delete: async (id) => {
    const res = await apiClient.delete(`/portfolios/${id}`);
    if (res.status !== 204) throw new Error('Failed to delete portfolio');
    return id;
  },

  // --- Stocks ---
  bulkCreateStocks: async (portfolioId, stocks) => {
    const res = await apiClient.post(`/portfolios/${portfolioId}/stocks/bulk`, stocks);
    if (res.status !== 201) throw new Error('Failed to bulk create stocks');
    return res.data;
  },

  fetchStocks: async (portfolioId) => {
    const res = await apiClient.get(`/portfolios/${portfolioId}/stocks/`);
    if (res.status !== 200) throw new Error('Failed to fetch portfolio stocks');
    return res.data;
  },

  updateStock: async (portfolioId, stockId, stockData) => {
    const res = await apiClient.put(`/portfolios/${portfolioId}/stocks/${stockId}`, stockData);
    if (res.status !== 200) throw new Error('Failed to update stock');
    return res.data;
  },

  deleteStock: async (portfolioId, stockId) => {
    const res = await apiClient.delete(`/portfolios/${portfolioId}/stocks/${stockId}`);
    if (res.status !== 204) throw new Error('Failed to delete stock');
    return stockId;
  },

  // --- Analytics ---
  createAnalytics: async (portfolioId, analyticsData) => {
    const res = await apiClient.post(`/portfolios/${portfolioId}/analytics/`, analyticsData);
    if (res.status !== 201) throw new Error('Failed to create analytics');
    return res.data;
  },

  fetchAnalytics: async (portfolioId) => {
    const res = await apiClient.get(`/portfolios/${portfolioId}/analytics/`);
    if (res.status !== 200) throw new Error('Failed to fetch analytics');
    return res.data;
  },

  updateAnalytics: async (portfolioId, analyticsData) => {
    const res = await apiClient.put(`/portfolios/${portfolioId}/analytics/`, analyticsData);
    if (res.status !== 200) throw new Error('Failed to update analytics');
    return res.data;
  }
};

export default PortfolioAPI;
